// Közös háttérképek. A képek a frontend/public/images/ alatt, WebP formátumban vannak
// (a fájlnevek nem hash-eltek: változtatáskor új fájlnevet kell adni, mert a /images/ cache 7 nap).

// Levelek-háttér (krém gradienssel): mobilon a *_mobile, desktopon a sima változat
export const LEAVES_BG_XS =
  'linear-gradient(rgba(245, 235, 220, 0.5), rgba(245, 235, 220, 0.5)), url(/images/levelek_mobile.webp)';
export const LEAVES_BG_MD =
  'linear-gradient(rgba(236, 225, 210, 0.51), rgba(245, 235, 220, 0.5)), url(/images/levelek.webp)';

// Rózsa-dekor (ServiceProviders fejléc)
export const ROZSAK_BG = 'url(/images/rozsak.webp)';

// Márvány háttér (lábléc)
export const MARBLE_BG = 'url(/images/marble.webp)';
